
import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../../_components/common/SideNavBar'
import { AnalyzeData } from '../../../../OrgAdminArea/SidebarData'
import { NavLink } from 'react-router-dom'
import { Tooltip } from 'reactstrap'
import AnalysisNavBar from '../../../../../../_components/common/AnalysisNavBar'
import RoutableSelects from '../../../../../../_components/common/RoutableSelects'
import CircularButtonGroup from '../../../../../../_components/common/CircularButtonGroup'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../../_actions';
import dataFormater from '../../../dataFormater'
import { global_data } from '../../../globalData'
import { lndAction } from '../../../../../../_actions/Analyze/lnd.action'
import buttonDataFormater from '../../../buttonDataFormater';

import SwotIcon from '../../../../../../images/swotIcon.png';


import achievementLogo from '../../../../../../images/achievement.png';
import sociabilityLogo from '../../../../../../images/sociability.png';
import leadershipLogo from '../../../../../../images/leadership.png';
import learningLogo from '../../../../../../images/learning.png';
import integrityLogo from '../../../../../../images/integrity.png';


import landdLogo from '../../../../../../images/landdroute.png';



class OrientationGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            selected_child: [],
            tooltipOpen: false,
            activeToolTipId: null
        }
    }

    componentDidUpdate(prev) {
        if (prev.lnd !== this.props.lnd) {
            this.props.data.map((ob, key) => {
                if ((ob.header_text == "Relationship" ? "sociability" : ob.header_text == "Nurturing" ? "integrity" : ob.header_text.toLowerCase()) == this.props.lnd) {
                    this.setState({ selected_child: ob.child_content })
                }
            })
        }
    }

    componentDidMount() {
        this.props.data.map((ob, key) => {
            if ((ob.header_text == "Relationship" ? 'sociability' : ob.header_text ==  "Nurturing" ? "integrity" : ob.header_text.toLowerCase()) == this.props.lnd) {
                this.setState({ selected_child: ob.child_content },()=> {
                })
            }
        })
    }

    toggleMultiple = (e, id) => {
        this.setState({ tooltipOpen: false, activeToolTipId: null }, () => {
            this.setState({ tooltipOpen: !this.state.tooltipOpen, activeToolTipId: id }, () => {
                if (e.type == 'mouseout') {
                    this.setState({ tooltipOpen: false })
                }
            })
        })

    }

    getAttrName = () => {
        return this.state.selected_child.filter(child => child.link == this.props.location.pathname)[0].child_header
    }

    render() {
        return (
            <div className="d-flex flex-column orientation-group-container" style={{width: '80%', margin: 'auto'}}>
                <div className="d-flex flex-row align-items-center ">
                    <CircularButtonGroup buttonGroupData={this.props.buttonGroupData} swotCatagory={this.props.match.params.lnd} singleButton={true} textAlign={"justify-content-start"} toolTip={false} uncontrolledButton={true} />
                    <div className="d-flex align-items-stretch w-100" style={{justifyContent: 'space-evenly'}}>
                        {
                            this.state.selected_child.map((val, key) => {
                                return (
                                    <NavLink key={key} to={val.link} className="d-flex align-items-center p-3 orientation-group-nav-link m-2" id={`TooltipExample${`${val.child_header}`.replace(/\s/g, '')}`} style={{ backgroundImage: val.child_content_background_color }} activeStyle={{
                                        backgroundImage: val.activeBackground,
                                        textDecoration: "none"
                                    }}
                                        activeClassName="orientation-group-nav-link-active"
                                    >
                                        <Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val.child_header}`.replace(/\s/g, '')} target={`TooltipExample${`${val.child_header}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val.child_header}`.replace(/\s/g, ''))} delay={{ show: 0, hide: 5 }}>
                                            {val.tool_tip_desc}
                                        </Tooltip>
                                        <h4 className="mb-0 orientation-group-nav-link-title">{val.child_header}</h4>
                                    </NavLink>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="my-2 px-3" style={{width: '80%', margin: 'auto'}}>
                    {
                        this.state.selected_child.map((val, key) => {
                            if(val.id == 'sociability') {
                            }
                            if (this.props.location.pathname == val.link) {
                                return (
                                    <div key={key} className="d-flex flex-column m-1">
                                        <p className="mb-0 text-center font-weight-bold" style={{fontSize: 12}}>The list of trainees is stack ranked from LOWEST to HIGHEST</p>
                                        <div className="d-flex flex-row px-0">
                                            <div className="p-2 m-1 orientation-group-header w-100">
                                                <h6 className="mb-0 text-left pl-3 font-italic font-weight-bold" style={{fontSize: 14}}>Trainee</h6>
                                            </div>
                                            <div className="p-2 m-1 orientation-group-header w-100">
                                                <h6 className="mb-0 text-left pl-3 font-italic font-weight-bold" style={{fontSize: 14}}>Preferred Learning Mode</h6>
                                            </div>
                                            <div className="p-2 m-1 orientation-group-header w-100">
                                                <h6 className="mb-0 text-left pl-3 font-italic font-weight-bold" style={{fontSize: 14}}>Recomended Peer Coach</h6>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column px-0">
                                            {
                                                val.attribute_detail.length ?
                                                    val.attribute_detail.sort((a,b) => a.trainee_score - b.trainee_score).map((obj1,key) => {
                                                        return (
                                                            <div key={key} className="d-flex flex-row px-0 w-100">
                                                                <div className="p-2 m-1 orientation-group-content w-100">
                                                                    <h6 className="mb-0 text-left pl-3 font-italic font-weight-bold word-break-custom" style={{fontSize: 13}}>{obj1.trainee ? obj1.trainee : obj1.trainee_email}</h6>
                                                                </div>
                                                                <div className="p-2 m-1 orientation-group-content w-100 font-light_italic_calibri-family">
                                                                    <h6 className="mb-0 text-left pl-3 font-italic word-break-custom" style={{fontSize: 13}}>{obj1.preferred_learning_mode}</h6>
                                                                </div>
                                                                <div className="p-2 m-1 orientation-group-content w-100 font-weight-bold">
                                                                    {
                                                                        obj1.recommended_peer_coach.length ?
                                                                            obj1.recommended_peer_coach.map((ob, key) => 
                                                                                (
                                                                                    <h6 key={key+ 'recommended_peer_coach'} className="mb-0 text-left pl-3 font-italic word-break-custom" style={{fontSize: 13}}>{ob.name ? ob.name : ob.email}</h6>
                                                                                )
                                                                            )
                                                                        :
                                                                            <h6 className="mb-0 text-left pl-3 font-italic" style={{fontSize: 13}}>none</h6>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    <div className="d-flex flex-row px-0 w-100">
                                                        <div className="p-2 m-1 orientation-group-content w-100">
                                                            <h6 className="mb-0 text-center pl-3 font-italic word-break-custom" style={{fontSize: 13}}>No Trainees associated with {this.getAttrName()}!</h6>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        )
    }


}

class LDOrientation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selection_id: 1,
            selected_route_parameter: null,
            navData: [],
            selectGroupData: [
                {
                    img: achievementLogo,
                    link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/achievement/1`,
                    id: "achievement",
                    name: "Achievement",
                    tooltip_id: 1
                },
                {
                    img: sociabilityLogo,
                    link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/sociability/1`,
                    id: "sociability",
                    name: "Relationship",
                    tooltip_id: 2
                },
                {
                    img: leadershipLogo,
                    link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/leadership/1`,
                    id: "leadership",
                    name: "Leadership",
                    tooltip_id: 3
                },
                {
                    img: learningLogo,
                    link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/learning/1`,
                    id: "learning",
                    name: "Learning",
                    tooltip_id: 4
                },
                {
                    img: integrityLogo,
                    link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/integrity/1`,
                    id: "integrity",
                    name: "Nurturing",
                    tooltip_id: 5
                },
            ],
            buttonGroupData: [
                {
                    img: landdLogo,
                    link: `/organisation/${props.match.params.id}/user/learning-and-development`,
                    name: "L&D",
                    id: 0,
                    tooltip_id: 0
                }
            ],
            data_second: [],
            lndLoader: false
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.lndDataResponse !== this.props.lndDataResponse) {
            if(this.props.lndDataResponse !== '') {
                this.setState({
                    lndLoader: true,
                    buttonGroupData: [
                        {
                            img: landdLogo,
                            link: `/organisation/${this.props.match.params.id}/user/learning-and-development`,
                            name: "L&D",
                            id: 0,
                            tooltip_id: 0
                        }
                    ]
                },() => {
                    this.setState({
                        data_second: dataFormater(this.props,this.props.lndDataResponse.data,"lnd_all"),
                        buttonGroupData: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.lndDataResponse.data,"lnd_all"),'l&d_all_button'))
                    },() => {
                        this.setState({
                            lndLoader: false
                        })
                    })
                })
            }
        }

        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
                })
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '') {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'L&D') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

         //filter data
         if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
            })
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        //ldn data
        if(this.props.lndDataResponse !== '') {
            this.setState({
                data_second: [],
                buttonGroupData: [
                    {
                        img: landdLogo,
                        link: `/organisation/${this.props.match.params.id}/user/learning-and-development`,
                        name: "L&D",
                        id: 0,
                        tooltip_id: 0
                    }
                ],
                lndLoader: true
            },() => {
                this.setState({
                    data_second: dataFormater(this.props,this.props.lndDataResponse.data,"lnd_all"),
                    buttonGroupData: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.lndDataResponse.data,"lnd_all"),'l&d_all_button'))
                },() => {
                    this.setState({
                        lndLoader: false
                    })
                })
            })
            
        }

    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    render() {
        const { navData, selectGroupData, buttonGroupData, data_second } = this.state
        const { getlndLoading, getlndError, getlndErrorMessage } = this.props;
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                               this.props.singleValidatorResponse ?
                               <p className="text-center">
                                    Team Members should be more than 2
                               </p>:
                                !getlndLoading && !getlndError ?
                                    this.state.lndLoader ?
                                        <p className="text-center my-3 text-dark">
                                            <i className="fas fa-spinner fa-spin " ></i>
                                            &nbsp;loading
                                        </p>
                                    :
                                        <div className="">
                                            <div className="d-flex justify-content-center drop-down-container my-5">
                                                <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Choose Orientation</h6>
                                                <RoutableSelects swotid={this.props.match.params.lnd} buttonGroupData={selectGroupData} {...this.props} />
                                            </div>
                                            <OrientationGroups key={this.state.data_second} lnd={this.props.match.params.lnd} lndcat={this.props.match.params.lndcat} data={data_second} {...this.props} buttonGroupData={buttonGroupData} />                                            
                                            <div className="gradient-flex px-5 col-8">
                                                <CircularButtonGroup buttonGroupData={buttonGroupData} swotCatagory={this.props.match.params.lnd} singleButton={false} textAlign={"justify-content-end"} />
                                            </div>
                                        </div>
                                :
                                    getlndError ?
                                        <p className="pt-5 text-center">{getlndErrorMessage}</p>
                                    :
                                        <p className="text-center my-3 text-dark">
                                            <i className="fas fa-spinner fa-spin " ></i>
                                            &nbsp;loading
                                        </p>
                        }
                    </div>
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

        //Competency data
        const { getlndLoading } = state.lndDataReducer
        const getlndError = state.lndDataReducer.error
        const getlndErrorMessage = state.lndDataReducer.errorMessage
        const lndDataResponse = (!getlndLoading && !getlndError) ?  state.lndDataReducer.data : '';
     
        //Header Permission
        const { headPerLoading } = state.headerPermissionReducer
        const headPerLoadingError = state.headerPermissionReducer.error
        const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;

    const singleValidatorResponse = state.singleValidatorReducer.data;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        getlndLoading,
        getlndError,
        getlndErrorMessage,
        lndDataResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,
        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(LDOrientation)



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/L&D/L&DOrientation/index.js